import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import { execGetRAFile } from "src/app/pages/inmatch/api/remittance-advice";
import { Link } from "lqx-react";
import { useIO, useLinked } from '@type-r/react';
import { Loading } from "lqx-react";

export const RemittanceDocumentLink = ({remittanceDocument, label, short, nolabel, originalFileName} : {
    remittanceDocument : string,
    label? : String,
    short? : Boolean,
    nolabel? : Boolean,
    originalFileName?: String,
}) => {
    const $doIO = useLinked( false );

    const isReady = useIO(
        async () => $doIO.isTruthy && await getFile(remittanceDocument),
        [ $doIO.value ]
    );
    const classes = useTextStyles();
    const getFile = async (remittanceDocument : string) => {
        const response = await execGetRAFile(remittanceDocument);
        if (response && response.status === 200) {
            const blob = await response.blob();

            const dataUrl = window.URL.createObjectURL(blob),
                a = document.createElement('a');

            a.href = dataUrl;
            a.download = getFileName(remittanceDocument);
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    };

    const getFileName = (remittanceDocument) => {
        return originalFileName || (remittanceDocument && (remittanceDocument.split("/").pop() || remittanceDocument));
    };

    return isReady ? 
        (<label className={ classes.root }>
            { !nolabel ?
            <span className={ classes.label }>
                { label ? label : 'Remittance Document' }
            </span> : undefined }
            {remittanceDocument ? 
            <div className={ classes.value }>
                <Link onClick={$doIO.true}>{ short ? 
                    <span title={getFileName(remittanceDocument)}>Download</span> :
                    getFileName(remittanceDocument) }</Link>
            </div> : undefined }
        </label>) : 
        <Loading/>;
}

const useTextStyles = makeStyles({
    root : {
        display: 'flex',
        flexDirection: 'row',
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,
        padding: '9px 0 10px 0',

        '&:focus-within' : {
            color: '#1084D3',
            fontWeight: 600,
        }
    },

    label: {
        flex: 2,
        alignSelf: 'center',
    },

    value : {
        flexDirection: 'column',
        flex : 3,
        display: 'inline-flex',
    },
});
